// extracted by mini-css-extract-plugin
export var divider = "_rs-0";
export var systemMessage = "_rs-1";
export var systemMessageWrapper = "_rs-2";